import { Route, Switch } from 'react-router-dom';
import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

import { AuthProvider } from './components/auth/contexts/AuthContext';
import { SubscriptionProvider } from './components/auth/contexts/SubscriptionContext';
import { SubscriptionFeature } from './components/auth/contexts/SubscriptionContext';
import { ProtectedRoute } from './components/auth/components/ProtectedRoute';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { VerifyMagicLink } from './pages/VerifyMagicLink';
import { VerifySubscription } from './pages/VerifySubscription';
import { ChangePassword } from './pages/ChangePassword';
import { SubscriptionPage } from './components/subscription/SubscriptionPage';
import Settings from './pages/Settings';
import Links from './pages/Links';
import NewLink from './pages/NewLink';
import EditLink from './pages/EditLink';
import Home from './pages/Home';

setupIonicReact();

const App: React.FC = () => {
    return (
        <IonApp>
            <IonReactRouter>
                <AuthProvider>
                    <SubscriptionProvider>
                        <IonRouterOutlet>
                            <Switch>
                                {/* Public routes */}
                                <Route path="/login" exact component={Login} />
                                <Route path="/register" exact component={Register} />
                                <Route path="/verify-magic-link" exact component={VerifyMagicLink} />
                                
                                {/* Protected routes */}
                                <ProtectedRoute 
                                    path="/verify-subscription" 
                                    exact 
                                    component={VerifySubscription} 
                                />
                                <ProtectedRoute 
                                    path="/subscription" 
                                    exact 
                                    component={SubscriptionPage} 
                                />
                                <ProtectedRoute 
                                    path="/change-password" 
                                    exact 
                                    component={ChangePassword} 
                                />
                                <ProtectedRoute 
                                    path="/settings" 
                                    exact 
                                    component={Settings} 
                                />
                                <ProtectedRoute 
                                    path="/links" 
                                    exact 
                                    component={Links} 
                                    requiredFeature={SubscriptionFeature.BASIC_LINKS}
                                />
                                <ProtectedRoute 
                                    path="/links/new" 
                                    exact 
                                    component={NewLink} 
                                    requiredFeature={SubscriptionFeature.BASIC_LINKS}
                                />
                                <ProtectedRoute 
                                    path="/links/edit/:id" 
                                    exact 
                                    component={EditLink} 
                                    requiredFeature={SubscriptionFeature.BASIC_LINKS}
                                />
                                <ProtectedRoute 
                                    path="/" 
                                    exact 
                                    component={Home} 
                                    requiredFeature={SubscriptionFeature.BASIC_LINKS}
                                />
                            </Switch>
                        </IonRouterOutlet>
                    </SubscriptionProvider>
                </AuthProvider>
            </IonReactRouter>
        </IonApp>
    );
}

export default App;